import { AvailabilityType } from '../../../../constants/availabilityType'
import { EventType } from '../../../../constants/eventType'

export const availabilityTypeToEventType = (action: 'create' | 'delete' | 'update', availabilityType: AvailabilityType): EventType => {
  switch (action) {
    case 'create':
      return availabilityType === AvailabilityType.AVAILABLE
        ? EventType.AVAILABILITY_CONSTRAINT_CREATED
        : EventType.UNAVAILABILITY_CONSTRAINT_CREATED
    case 'delete':
      return availabilityType === AvailabilityType.AVAILABLE
        ? EventType.AVAILABILITY_CONSTRAINT_DELETED
        : EventType.UNAVAILABILITY_CONSTRAINT_DELETED
    case 'update':
      return availabilityType === AvailabilityType.AVAILABLE
        ? EventType.AVAILABILITY_CONSTRAINT_UPDATED
        : EventType.UNAVAILABILITY_CONSTRAINT_UPDATED
    default:
      const exhaustiveCheck: never = action // This will yell at design time if we aren't exhaustive

      throw new Error(`EXHAUSTIVE CHECK: Unsupported action (${exhaustiveCheck}) and availability type (${availabilityType}) combination`)
  }
}
